import React from "react";
import "./Chip.css";

interface ChipProps {
    children: React.ReactNode;
    className?: string;
}

export function Chip({ children, className }: ChipProps) {
    return <span className={`atom-chip ${className || ""}`}>{children}</span>;
}

export default Chip;
